/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
import PaletteIconPause from '@telus-uds/palette-koodo/build/rn/icons/Pause'
import PaletteIconPlay from '@telus-uds/palette-koodo/build/rn/icons/Play'
import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: { showPanelTabs: false, showPreviousNextNavigation: false }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    iconBackgroundColor: '#ffffff',
    nextIcon: PaletteIconChevronRight,
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlay,
    previousIcon: PaletteIconChevronLeft,
    showPanelNavigation: true,
    showPanelTabs: true,
    showPreviousNextNavigation: true,
    spaceBetweenSlideAndPanelNavigation: 32,
    spaceBetweenSlideAndPreviousNextNavigation: 24,
    stepTrackerCurrentBackgroundColor: '#ffffff'
  }
}
export default theme
